import { useEffect, useState } from "react";
import { api, fmtTime } from "@/lib/api";
import { PageHeader, EmptyState } from "@/components/bits";

export default function AuditLog() {
  const [entries, setEntries] = useState([]);

  useEffect(() => {
    let alive = true;
    const load = () =>
      api
        .get("/audit?limit=200")
        .then((r) => alive && setEntries(r.data))
        .catch(() => {});
    load();
    const t = setInterval(load, 10000);
    return () => {
      alive = false;
      clearInterval(t);
    };
  }, []);

  return (
    <div data-testid="audit-page">
      <PageHeader title="Audit-Log" sub="Alle sicherheitsrelevanten Aktionen — ohne Secrets, ohne Passwörter" />
      {entries.length ? (
        <div className="panel overflow-x-auto" data-testid="audit-table-panel">
          <table className="w-full text-sm" data-testid="audit-table">
            <thead>
              <tr className="border-b border-border text-left">
                <th className="mono-label font-normal px-5 py-3">Zeit</th>
                <th className="mono-label font-normal px-3 py-3">Aktion</th>
                <th className="mono-label font-normal px-3 py-3">Akteur</th>
                <th className="mono-label font-normal px-3 py-3">Ziel</th>
                <th className="mono-label font-normal px-3 py-3">Details</th>
              </tr>
            </thead>
            <tbody>
              {entries.map((a) => (
                <tr key={a.id} className="border-b border-border/50 hover:bg-slate-800/30 transition-colors" data-testid={`audit-row-${a.id}`}>
                  <td className="px-5 py-2.5 font-mono text-xs text-slate-300 whitespace-nowrap">{fmtTime(a.created_at)}</td>
                  <td className="px-3 py-2.5">
                    <span className="font-mono text-[10px] uppercase tracking-widest text-cyan-400 border border-cyan-500/30 bg-cyan-500/10 px-1.5 py-0.5 rounded-sm">
                      {a.action}
                    </span>
                  </td>
                  <td className="px-3 py-2.5 text-xs text-slate-400">{a.actor_name || a.actor_email || "System"}</td>
                  <td className="px-3 py-2.5 font-mono text-[10px] text-slate-300">
                    {a.target_type ? `${a.target_type}:${(a.target_id || "").slice(0, 8)}` : "—"}
                  </td>
                  <td className="px-3 py-2.5 font-mono text-[10px] text-slate-400 max-w-xs truncate">
                    {a.meta && Object.keys(a.meta).length ? JSON.stringify(a.meta) : "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <EmptyState text="Noch keine Audit-Einträge" testid="audit-empty" />
      )}
    </div>
  );
}
